import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { UserSearchInput } from "@/components/user/UserSearchInput";
import { trackEvent } from "@/utils/trackEvent";
import { useIsMyDoc } from "@/utils/useIsMyDoc";

import type { DocumentModel } from "@/models/DocumentModel";

export const SearchUserContent = observer(function SearchUserContent({
  doc,
}: {
  doc: DocumentModel;
}) {
  const t = useTranslations();
  const isMyDoc = useIsMyDoc(doc);

  return (
    isMyDoc && (
      <UserSearchInput
        searchMode="team"
        placeholder={t("share.inputPlaceholder")}
        onTeamClick={async (team) => {
          await doc.permissions.createPermission(
            { permalink: team.permalink },
            doc.permissions.scopeToGive,
          );
          if (doc.id) {
            trackEvent("share_user_invited", {
              username: team.permalink,
              doc_id: doc.id,
            });
          }
        }}
        onEmailClick={async (email) => {
          await doc.permissions.createPermission({ email }, doc.permissions.scopeToGive);
          if (doc.id) {
            trackEvent("share_user_invited", {
              username: email,
              doc_id: doc.id,
            });
          }
        }}
        /* TODO: add copy invite link button here. it waits for BE to implement the endpoint */
      />
    )
  );
});
